module.exports = __webpack_public_path__ + "img/tab_button_img4_mobile.628d1b7e.png";